module.exports = __webpack_public_path__ + "img/interactive-fountain_12.5c6657fe.jpg";